import { useState } from "react";
import {
  Button,
  Container,
  Grid,
  Typography,
  TextField,
  Box,
  Paper,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify"; // Import toast and ToastContainer
import "react-toastify/dist/ReactToastify.css"; 
import img3 from "../../images/img3.png";
import img2 from "../../images/img2.png";
import img4 from "../../images/img4.png";
import img1 from "../../images/img1.png";
import img5 from "../../images/img5.png";
import img6 from "../../images/img6.png";
import logo from "../../images/rethinkpack.png";
import Navbar from "./Navbar";

const Index = () => {
  const [formData, setFormData] = useState({
    name: "",
    organisation: "",
    designation: "",
    email: "",
    message: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    toast({
      title: "Message sent!",
      description: "We'll get back to you soon.",
    });
    setFormData({
      name: "",
      organisation: "",
      designation: "",
      email: "",
      message: "",
    });
  };
            
  return (
    <Box className="min-h-screen">
      <Navbar/>
      {/* Hero Section */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <img src={logo} alt="Assessment Tool" 

                style={{ width: "12rem" }}
              />
              <Typography variant="h3" sx={{ fontWeight: "bold", color: "primary.main" }}>
                Design Your Sustainable Packaging Solutions. Right From The Start With Optimal Effectiveness
              </Typography>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "primary.light",
                    color: "black",
                    "&:hover": { bgcolor: "primary.main" },
                  }}
                >
                  Book A Demo
                </Button>
                <Button
                  variant="outlined"
                  sx={{ bgcolor: "white", color: "black" }}
                >
                  Find Out More
                </Button>
              </Box>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Typography variant="h6" sx={{ color: "#5a6fa4", fontWeight: "bold" }}>
                    Sustainability & Circularity
                  </Typography>
                  <Typography sx={{ color: "rgba(90, 111, 164, 0.8)" }}>
                    Assess the sustainability and circularity of your entire packaging component according to the Circular Economy Guideline.
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="h6" sx={{ color: "#5a6fa4", fontWeight: "bold" }}>
                    Country Specific Legislative
                  </Typography>
                  <Typography sx={{ color: "rgba(90, 111, 164, 0.8)" }}>
                    Navigate the complexity of your desired country-specific legislation to meet their packaging requirements.
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <img src={img1} alt="Service Image" style={{ width: "100%" }} />
          </Grid>
        </Grid>
      </Container>

      {/* Assessment Tool Section */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Typography
          variant="h4"
          align="center"
          sx={{ color: "orange", fontWeight: "bold", mb: 4 }}
        >
          Evaluate your Sustainable Packaging Design With Our Online Assessment Packaging Tool
        </Typography>
        <img src={img2} alt="Assessment Tool" style={{ width: "100%" }} />
      </Container>

      {/* Benefits Section */}
      <Box sx={{ bgcolor: "#65BAF9", py: 6 }}>
        <Container maxWidth="lg">
          <Typography
            variant="h4"
            align="center"
            sx={{ color: "orange", fontWeight: "bold", mb: 4 }}
          >
            An Integrated Packaging Criteria
          </Typography>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Paper sx={{ p: 4 }}>
                <Grid container spacing={4} alignItems="center">
                  <Grid item xs={12} md={6} sx={{ display: "flex", justifyContent: "center" }}>
                    <img src={img4} alt="Sustainability" style={{ width: "40%" }} />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box sx={{ textAlign: "center" }}>
                      <Typography variant="h5" sx={{ color: "#5a6fa4", fontWeight: "bold", mb: 2 }}>
                        Sustainability and Circularity
                      </Typography>
                      <Typography sx={{ color: "#64b4ef", mb: 2 }}>
                        An online platform, user-friendly and accessible, empowering packaging designers to validate their designs against Circular Economy Packaging Design criteria and generate results.
                      </Typography>
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: "#93c3ea",
                          color: "black",
                          "&:hover": { bgcolor: "#64b4ef" },
                        }}
                      >
                        Find Out More
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper sx={{ p: 4 }}>
                <Grid container spacing={4} alignItems="center">
                  <Grid item xs={12} md={6} sx={{ display: "flex", justifyContent: "center" }}>
                  <img src={img3} alt="Assessment Tool" style={{ width: "40%" }} />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box sx={{ textAlign: "center" }}>
                      <Typography variant="h5" sx={{ color: "#5a6fa4", fontWeight: "bold", mb: 2 }}>
                        Country Specific Legislative
                      </Typography>
                      <Typography sx={{ color: "#64b4ef", mb: 2 }}>
                        Effortlessly navigate the intricate terrain of specific countries' packaging legislation and Extended Producer Responsibility (EPR) mandates.
                      </Typography>
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: "#93c3ea",
                          color: "black",
                          "&:hover": { bgcolor: "#64b4ef" },
                        }}
                      >
                        Find Out More
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>

  <>
  
  <Box sx={{ py: 6, bgcolor: "#f9f9f9" }}>
    <Container maxWidth="lg">
      <Typography
        variant="h4"
        align="center"
        sx={{ color: "orange", fontWeight: "bold", mb: 4 }}
      >
        A magnitude of benefits that assist companies in adopting sustainable packaging
      </Typography>
      <Grid container spacing={4}>
        {/* Left Column with Text Content */}
        <Grid item xs={12} md={6}>
          {[
            {
              title: "Optimized Packaging Choices",
              description:
                "Making informed decisions as early as the designing stage reduces the cost of errors and resource wastage.",
            },
            {
              title: "Regulatory Compliance & Market Expansion",
              description:
                "Stay compliant and expand into new markets by meeting specific legislative requirements.",
            },
            {
              title: "Greenwashing Prevention",
              description:
                "Align your packaging with genuine sustainability designs to avoid greenwashing claims and protect your brand reputation.",
            },
            {
              title: "EPR Ready",
              description:
                "Prepare for Extended Producer Responsibility (plastic tax calculation) and reduce financial implications.",
            },
            {
              title: "Traceability",
              description:
                "Enable tracing from the source and streamline packaging design processes with supplier information.",
            },
            {
              title: "Environmental Reporting & Sustainable Goals",
              description:
                "Contribute to sustainability goals and enhance commitment to environmental stewardship.",
            },
          ].map((benefit, index) => (
            <Box key={index} sx={{ mb: 4 }}>
              <Typography
                variant="h6"
                sx={{ color: "#0056b3", fontWeight: "bold" }}
              >
                {benefit.title}
              </Typography>
              <Typography>{benefit.description}</Typography>
            </Box>
          ))}
        </Grid>

        {/* Right Column with Benefit Cards */}
        <Grid item xs={12} md={6}>
  <Grid container spacing={2}>
    {[
      "MEETING CONSUMER DEMAND FOR SUSTAINABLE PACKAGING",
      "IMPROVE COMPANY & BRAND IMAGE",
      "REDUCE TIME & RESOURCES",
      "RISK MANAGEMENT (AVOID GREENWASHING IMAGE)",
      "REDUCE FINANCIAL IMPLICATION",
      "SAVE COST",
      "MEETING SUSTAINABLE GOALS",
      "MEETING EXPORTING COUNTRY LEGISLATIVE",
    ].map((cardText, index) => (
      <Grid item xs={12} sm={6} key={index}>
        <Paper
          elevation={3}
          sx={{
            p: 2,
            textAlign: "center",
            bgcolor: "#65BAF9",
            color: "white",
            fontWeight: "bold",
            borderRadius: "20px 0px 20px 0px", // Diagonal corner styles
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "120px", // Consistent height
            margin: "10px", // Spacing between cards
          }}
        >
          {cardText}
        </Paper>
      </Grid>
    ))}
  </Grid>
</Grid>
      </Grid>
    </Container>
  </Box>


    {/* Existing CustomSection Content */}
    <Box sx={{ py: 6, bgcolor: "#f9f9f9" }}>
      {/* ...existing CustomSection code... */}
    </Box>

    {/* Advantages Section */}
    <Box id="advantages-section" sx={{ py: 5, bgcolor: "#65BAF9" }}>
      <Container>
        <Typography
          variant="h4"
          align="center"
          sx={{ color: "orange", fontWeight: "bold", mb: 4 }}
        >
          Simple, User-Friendly and Time Efficient
        </Typography>
        <Grid container spacing={2}>
          {[
            {
              title: "Evaluate and Analyse",
              description:
                "Evaluate the design and materials utilized for all packaging components to ascertain the degree to which your packaging adheres to sustainable design principles, referencing the Circular Economy Packaging Guideline.",
            },
            {
              title: "Identify shortcomings and explore solutions",
              description:
                "Results pinpoint areas for improvement and explore tailored recommendations that best suit your needs and resources.",
            },
            {
              title: "Specific Country Guideline",
              description:
                "Complete a brief questionnaire specifying the country, and our algorithm will furnish all pertinent information to address any shortcomings, ensuring compliance.",
            },
            {
              title: "Integrated Packaging Data",
              description:
                "Centralize all packaging data within a unified system, facilitating retrieval and editing whenever packaging design modifications occur, while also providing alerts for any changes in country legislation.",
            },
          ].map((item, index) => (
            <Grid item xs={12} md={3} key={index}>
              <Box
                sx={{
                  bgcolor: "white",
                  p: 2,
                  height: 365,
                  mx: 1,
                  boxShadow: 2,
                  borderRadius: "20px 0px 20px 0px", // Diagonal corner styles
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ color: "#2f98e9", fontWeight: "bold" }}
                >
                  {item.title}
                </Typography>
                <Typography sx={{ color: "#2f98e9" }}>
                  {item.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>

    {/* Categories Section */}
    <Box id="categories-section" sx={{ py: 5 }}>
      <Container>
        <Typography
          variant="h4"
          align="center"
          sx={{ color: "orange", fontWeight: "bold", mb: 4 }}
        >
          A wide range of categories and specific components tailored to fulfill
          your individual requirements
        </Typography>

        <Grid 
  container 
  spacing={4} 
  justifyContent="center" // Ensures items are centered with justified gaps
>
  {[
    {
      src: img5,
      title: "ALL PACKAGED FOOD",
    },
    {
      src: img6,
      title: "ALL PACKAGED DRINKS",
    },
  ].map((item, index) => (
    <Grid 
      item 
      xs={12} 
      sm={6} 
      md={4} 
      key={index}
      display="flex" 
      justifyContent="center" // Centers individual grid items
    >
      <Box
        sx={{
          textAlign: "center",
          p: 3,
          bgcolor: "white",
          borderRadius: "20px 0px 20px 0px", // Diagonal corner styles
          boxShadow: 3,
          maxWidth: 300, // Set a max width for consistency
        }}
      >
        <img
          src={item.src}
          alt={item.title}
          style={{
            width: "80%", 
            marginBottom: "1rem", 
            borderRadius: 0, // Removes border-radius for the image
          }}
        />
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          {item.title}
        </Typography>
      </Box>
    </Grid>
  ))}
</Grid>

        <Grid container spacing={2} sx={{ mt: 4 }}>
          {[
            {
              bgcolor: "lightblue",
              text: "Primary Packaging, Secondary Packaging",
              color: "#65BAF9",
            },
            {
              bgcolor: "#e3f8c6",
              text:
                "Main Component, Additional Component, Closure / Lid, Wrapper / Label, Accessories",
              color: "rgb(214, 124, 14)",
            },
            {
              bgcolor: "lightgray",
              text:
                "Hard Plastic, Flexible Plastic, Paper / Cardboard, Metal / Aluminium, Glass, Bio Base & Plant Based",
              color: "#626f98",
            },
          ].map((item, index) => (
            <Grid item xs={12} key={index}>
              <Box
                sx={{
                  bgcolor: item.bgcolor,
                  p: 2,
                  borderRadius: "20px 0px 20px 0px", // Diagonal corner styles
                  textAlign: "center",
                  boxShadow: 1,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ color: item.color, fontWeight: "bold" }}
                >
                  {item.text}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>

    {/* Mission Section */}
    <Box sx={{ py: 5, bgcolor: "#65BAF9" }}>
      <Container>
        <Typography
          variant="h5"
          align="center"
          sx={{ color: "#4c74b0", mb: 4 }}
        >
          We are a young startup driven by a passion to combat packaging
          pollution by revolutionary shift packaging practices through holistic
          sustainable & circular economy design and redesign waste out from the
          system. <br /> Our mission is to analyze and provide solutions for any
          challenges that may arise in the packaging design process.
        </Typography>
        <Typography
          variant="h4"
          align="center"
          sx={{ color: "orange", fontWeight: "bold" }}
        >
          Let's Re
          <span style={{ color: "#c7f28a" }}>Think</span> Packaging
        </Typography>
      </Container>
    </Box>
  </>
);




      {/* Contact Section */}
      <Box sx={{ bgcolor: "#cbf285", py: 6 }}>
        <Container maxWidth="lg">
          <Typography variant="h4" align="center" sx={{ color: "#70aed7", mb: 4 }}>
            Let's explore together how we can collaborate with revolutionary shifting the packaging practice & make an impact for our environment!
          </Typography>
          <Typography variant="h5" sx={{ color: "#70aed7", mb: 3 }}>
            <center>
            Explore with us:</center>
          </Typography>
          <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 600, mx: "auto" }}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Organisation"
                  value={formData.organisation}
                  onChange={(e) => setFormData({ ...formData, organisation: e.target.value })}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Designation"
                  value={formData.designation}
                  onChange={(e) => setFormData({ ...formData, designation: e.target.value })}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  type="email"
                  label="Email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  label="Message"
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  required
                />
              </Grid>
              <Grid item xs={12} sx={{ textAlign: "center" }}>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    bgcolor: "#64b4ef",
                    "&:hover": { bgcolor: "#93c3ea" },
                    color: "white",
                  }}
                >
                  Contact us
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Index;